import {
  FETCHING_ANALYST_DONE,
  FETCHING_ANALYST_REQUEST,
  FETCHING_MATCHES_DONE,
  FETCHING_MATCHES_REQUEST,
  FETCHING_ORGANIZER_DONE,
  FETCHING_ORGANIZER_REQUEST,
  GET_ANALYST_LIST_RESPONSE,
  GET_MATCHES_LIST_RESPONSE,
  GET_ORGANIZER_LIST_RESPONSE,
  UPDATING_ANALYST_DONE,
  UPDATING_ANALYST_REQUEST,
  UPDATING_PORT_DONE,
  UPDATING_PORT_REQUEST,
} from "../actions/adminAction/types";

const INITIAL_STATE = {
  allMatches: [],
  allOrganizer: [],
  allAnalyst: [],
  fetchingMatches: false,
  fetchingAnalysts: false,
  fetchingOrganizers: false,
  updatingAnalysts: false,
  portingAccounts: false,
};
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCHING_MATCHES_REQUEST:
      return { ...state, fetchingMatches: true };
    case FETCHING_MATCHES_DONE:
      return { ...state, fetchingMatches: false };
    case FETCHING_ANALYST_REQUEST:
      return { ...state, fetchingAnalysts: true };
    case FETCHING_ANALYST_DONE:
      return { ...state, fetchingAnalysts: false };
    case FETCHING_ORGANIZER_REQUEST:
      return { ...state, fetchingOrganizers: true };
    case FETCHING_ORGANIZER_DONE:
      return { ...state, fetchingOrganizers: false };

    case UPDATING_ANALYST_REQUEST:
      return { ...state, updatingAnalysts: true };
    case UPDATING_ANALYST_DONE:
      return { ...state, updatingAnalysts: false };

    case UPDATING_PORT_REQUEST:
      return { ...state, portingAccounts: true };
    case UPDATING_PORT_DONE:
      return { ...state, portingAccounts: false };

    case GET_MATCHES_LIST_RESPONSE:
      return { ...state, allMatches: action.payload };
    case GET_ORGANIZER_LIST_RESPONSE:
      return { ...state, allOrganizer: action.payload };
    case GET_ANALYST_LIST_RESPONSE:
      return { ...state, allAnalyst: action.payload };

    default:
      return state;
  }
};
